export const Header = () => {
  return (
    <header>
      <h1>Two Hour Schmooze Radio</h1>
    </header>
  );
};
